module.exports = __webpack_public_path__ + "img/brazil-square.19d3ffb7.png";